export default "__VITE_ASSET__CGB5Licn__"